import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router'


@Component({
  selector: 'mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.sass']
})
export class MobileMenuComponent implements OnInit {


  public appStore: Array<string>;
  public socialMedia: string;

  constructor(
    private location: Location,
    private router: Router) {

    router.events.forEach((event) => {

      if (event instanceof NavigationEnd) {

        if (event.url.toString().includes('find-address')) {
          this.appStore = ['Шукайте поштове відділення у мобільному застосунку або через чат-бота Укрпошти.', 'Завантажити мобільний застосунок'];
          this.socialMedia = 'Написати чат-боту';
        }

        if (event.url.toString().includes('find-post-index')) {
          this.appStore = ['Дізнайтеся поштовий індекс у мобільному застосунку або через чат-бота Укрпошти.', 'Завантажити мобільний застосунок'];
          this.socialMedia = 'Написати чат-боту';
        }

        if (!event.url.toString().includes('find-post-index') && !event.url.toString().includes('find-address')) {
          // condition for init state when empty route changes to 'find index'

          this.appStore = ['Дізнайтеся поштовий індекс у мобільному застосунку або через чат-бота Укрпошти.', 'Завантажити мобільний застосунок'];
          this.socialMedia = 'Написати чат-боту';
        }

      }
    });

  }

  ngOnInit() {

  }

}
